import { Injectable } from '@angular/core';
import {
  Http,
  Response,
  RequestOptions,
  Headers,
  Request,
  RequestMethod,
  RequestOptionsArgs,
  ResponseContentType

} from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/finally';
import 'rxjs/add/observable/throw';
import { URLSearchParams } from '@angular/http';
import { BaseUrl } from "../urls/base.url";
import { HeaderComponent } from "../../components/header/header.component";
import { AuthHelper } from "../../common/auth.helper";
import { AppConstants } from '../../shared/constants/constants';
import { DialogService } from './dialog.service';
import { SpinnerService } from '../../components/spinner/spinner.service';
import { AuthService } from './auth.service';

@Injectable()
export class BaseService {

  constructor(private http: Http,
    public dialogService: DialogService,
    private authService: AuthService,
    private spinnerService: SpinnerService
  ) {
  }

  public static get token(): string {
    let token = localStorage.getItem(AppConstants.localStorage.token);
    return token;
  }

  public static get centreId(): string {
    let centreId = localStorage.getItem(AppConstants.localStorage.centreId);
    return centreId;
  }


  create(url: string, data: any) {
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Post,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: JSON.stringify(data)
    });

    return this.execute(options);
  }

  update(url: string, data: any) {

    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Put,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: JSON.stringify(data)
    });

    return this.execute(options);
  }

  postData(url: string, data: any) {
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Post,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: data
    });
    return this.execute(options);
  }

  remove(url: string, id: any, headers?: any) {
    let options = new RequestOptions({
      method: RequestMethod.Delete,
      url: BaseUrl.BASE_URL + url + '/' + id,
      headers: headers
    });

    return this.execute(options);
  }

  getAll(url: string) {
    var headers = this.setHeaders();

    let options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
    });

    return this.execute(options);
  }

  getById(url: string, id: any) {
    let params: URLSearchParams = new URLSearchParams();
    params.set('id', id);
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      search: params
    });

    return this.execute(options);
  }

  downloadFile(url: string) {
    var headers = this.setHeaders();
    let options = new RequestOptions({
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      responseType: ResponseContentType.Blob,
    });

    return this.execute(options);
  }

  getData(url: string, data: any | URLSearchParams = null): Observable<Response> {
    const headers = this.setHeaders();
    const params = new URLSearchParams();
    if (data) {
      if (data instanceof URLSearchParams) {
        params.setAll(data);
      } else {
        for (const key in data) {
          if (data[key] != null && data[key] != undefined && data[key] != NaN && data.hasOwnProperty(key)) {
            //   if (data[key] && data[key].toString() === '*') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('*', '%2A'));
            //   } else if (data[key] && data[key].toString() === '!') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('!', '%21'));
            //   } else if (data[key] && data[key].toString() === '~') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('~', '%7E'));
            //   } else if (data[key] && data[key].toString() === '(') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('(', '%28'));
            //   } else if (data[key] && data[key].toString() === ')') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace(')', '%29'));
            //   } else if (data[key] && data[key].toString() === '\'') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('\'', '%27'));
            //   } else if (data[key] && data[key].toString() === '#') {
            //     params.set(key, encodeURIComponent(data[key]).toString().replace('#', '%23'));
            //   } else {
            //     params.set(key, encodeURIComponent(data[key]));
            //   }
            //let strParams = encodeURIComponent(data[key]).toString();
            // strParams = strParams.replace('(', '%28');
            // strParams = strParams.replace(')', '%29');
            let strParams = data[key].toString();
            params.set(key, strParams);
          }
        }
      }
    }

    const options = new RequestOptions({
      params: params,
      method: RequestMethod.Get,
      url: BaseUrl.BASE_URL + url,
      headers: headers
    });

    return this.execute(options);
  }

  get(url: string, options?: RequestOptionsArgs): Observable<Response> {

    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Get;
    reqOpts.url = BaseUrl.BASE_URL + url;

    return this.execute(reqOpts);
  }

  post(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Post;
    reqOpts.url = BaseUrl.BASE_URL + url;
    reqOpts.body = body;

    return this.execute(reqOpts);
  }

  put(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }


    reqOpts.method = RequestMethod.Put;
    reqOpts.url = BaseUrl.BASE_URL + url;
    reqOpts.body = body;

    return this.execute(reqOpts);
  }

  delete(url: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};
    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }


    reqOpts.method = RequestMethod.Delete;
    reqOpts.url = BaseUrl.BASE_URL + url;

    return this.execute(reqOpts);
  }

  upload(url: string, data: any) {
    const headers = this.setHeadersForUpLoadFile();
    const options = new RequestOptions({
      method: RequestMethod.Post,
      url: BaseUrl.BASE_URL + url,
      headers: headers,
      body: data
    });
    return this.execute(options);
  }

  patch(url: string, body: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }

    reqOpts.method = RequestMethod.Patch;
    reqOpts.url = BaseUrl.BASE_URL + url;
    reqOpts.body = body;

    return this.execute(reqOpts);
  }

  head(url: string, options?: RequestOptionsArgs): Observable<Response> {
    let reqOpts = options || {};

    if (reqOpts.headers) {
      reqOpts.headers = new Headers(reqOpts.headers);
    } else {
      reqOpts.headers = this.setHeaders();
    }


    reqOpts.method = RequestMethod.Head;
    reqOpts.url = BaseUrl.BASE_URL + url;

    return this.execute(reqOpts);
  }


  private execute(options: any) {
    //noinspection TypeScriptUnresolvedFunction
    this.spinnerService.show();
    return this.http.request(new Request(options)).catch(
      error => {
        console.log("execute error");
        let errMsg = 'error';
        if (error.status === 401 && error.statusText === 'Unauthorized') {
          console.log('get refresh token');
          this.authService.refreshToken();
          return Observable.throw('no error');
        } else if (error.status === 403) {
          // Notification.notify(null, 'danger', 'Do not have permission to edit this item.');
        } else if (error.status === 500 || error.status === 400) {
          let errMsg = error.json();
          this.dialogService.openErrorDialog({ message: errMsg.message });
        } else {
          let errMsg = error.json();
          console.log(errMsg);
        }
        //Notification.notify($('main-app'), 'danger', error);
        return Observable.throw(error);
      }).finally(
        () => {
          this.spinnerService.hide();
        });
  }

  public setHeaders(header?: HeaderComponent) {
    let authHeaders;
    if (!header) {
      authHeaders = new Headers();
    }
    authHeaders.append('Content-Type', 'application/json; charset=utf-8');
    authHeaders.append('Accept', 'application/json');
    authHeaders.append('Authorization', 'bearer ' + BaseService.token);
    authHeaders.append('TimezoneOffsetUtcLocal', new Date().getTimezoneOffset());
    if (BaseService.centreId) {
      authHeaders.append('SelectedCentreId', BaseService.centreId);
    }
    return authHeaders;
  }

  public setHeadersForUpLoadFile(header?: HeaderComponent) {
    let authHeaders;
    if (!header) {
      authHeaders = new Headers();
    }

    authHeaders.append('Authorization', 'bearer ' + BaseService.token);
    authHeaders.append('TimezoneOffsetUtcLocal', new Date().getTimezoneOffset());
    // authHeaders.append('Content-Type', 'application/x-www-form-urlencoded');
    if (BaseService.centreId) {
      authHeaders.append('SelectedCentreId', BaseService.centreId);
    }
    return authHeaders;
  }

  public logout() {
    //this.authService.logout();
    AuthHelper.resetLocalStorage();
    window.location.href = '/landing';
  }

  private setAuthenticateReportHeaders(clientId: string) {
    let authHeaders;
    authHeaders = new Headers();
    authHeaders.append('Content-Type', 'application/json; charset=utf-8');
    authHeaders.append('Accept', 'application/json');
    authHeaders.append('Authorization', 'bearer ' + BaseService.token);
    authHeaders.append('client_id', clientId);

    return authHeaders;
  }
  public authenticateReportSite(reportServiceUrl: string, clientId: string): Observable<Response> {
    const reqOpts = {
      headers: this.setAuthenticateReportHeaders(clientId),
      method: RequestMethod.Post,
      url: reportServiceUrl + '/Authenticate'
    };
    return this.execute(reqOpts);
  }
}



// WEBPACK FOOTER //
// D:/TMB/TMB/MYTMB.UI/src/app/shared/services/base.service.ts